<template>
    <div class="main">
        <c-panel title="ESCALA DO RODÍZIO" titleIcon="fas fa-calendar-week">
            <el-alert type="info" :closable="false" class="u-mb-15"
                title="Expande o regime de rodízio em faixas de datas concretas."
                description="A escala é o que responde &quot;em que modo o grupo A está no dia 12/03?&quot; — e é ela que o diário consulta."></el-alert>

            <el-form label-position="top" @submit.native.prevent>
                <el-row :gutter="10" class="u-mb-15">
                    <el-col :xs="24" :sm="10">
                        <el-form-item label="Configuração" class="u-mb-0">
                            <el-select v-model="configuracaoId" filterable style="width: 100%;" @change="configuracaoMudou">
                                <el-option v-for="c in configuracoes" :key="c.id" :value="c.id"
                                    :label="c.nome + ' — ' + rotulo(c.regime_rodizio)"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="5">
                        <el-form-item label="Início" class="u-mb-0">
                            <el-date-picker v-model="dataInicio" type="date" format="dd/MM/yyyy"
                                value-format="yyyy-MM-dd" style="width: 100%;"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="5">
                        <el-form-item label="Fim" class="u-mb-0">
                            <el-date-picker v-model="dataFim" type="date" format="dd/MM/yyyy"
                                value-format="yyyy-MM-dd" style="width: 100%;"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="4" class="u-text-right u-mt-25">
                        <el-button v-if="podeEscrever" type="primary" size="small" icon="el-icon-magic-stick"
                            :disabled="!configuracaoId || !dataInicio || !dataFim" @click="gerar">GERAR ESCALA</el-button>
                    </el-col>
                </el-row>
            </el-form>

            <el-alert v-if="semRodizio" type="warning" :closable="false" class="u-mb-15"
                title="Esta configuração é &quot;sem rodízio&quot;."
                description="Cada grupo opera sempre no seu modo padrão — não há escala a gerar."></el-alert>

            <!-- ==================== CALENDÁRIO DO RODÍZIO ==================== -->
            <div v-if="configuracaoId && !semRodizio">
                <el-row :gutter="10" class="u-mb-10">
                    <el-col :xs="24" :sm="12">
                        <el-select v-model="turmaId" clearable filterable style="width: 100%;" size="small"
                            placeholder="Ver a escala de uma turma" @change="carregarEscala">
                            <el-option v-for="t in turmas" :key="t.id" :value="t.id"
                                :label="t.nome + ' — ' + t.instituicao"></el-option>
                        </el-select>
                    </el-col>
                </el-row>

                <div v-if="grupos.length" class="container-table">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th style="width: 160px;">Grupo</th>
                                <th v-for="f in faixas" :key="f.chave" class="u-text-center">
                                    {{ dataBr(f.inicio) }}<br><small>a {{ dataBr(f.fim) }}</small>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="g in grupos" :key="g.id">
                                <td>
                                    {{ g.nome }}
                                    <div><small class="u-text-muted">padrão: {{ g.modo_padrao }}</small></div>
                                </td>
                                <td v-for="f in faixas" :key="f.chave" class="u-text-center">
                                    <el-tag size="mini" :type="corModo(modoNaFaixa(g, f))">
                                        {{ modoNaFaixa(g, f) || '—' }}
                                    </el-tag>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <el-alert v-else-if="turmaId" type="info" :closable="false"
                    title="Esta turma ainda não tem grupos gerados nesta configuração."
                    description="Gere os grupos na tela Grupos por Turma antes de montar a escala."></el-alert>

                <el-alert v-else type="info" :closable="false"
                    title="Selecione uma turma para visualizar o calendário do rodízio."></el-alert>
            </div>
        </c-panel>
    </div>
</template>
<script>
/** BLOCO H — item 122: escala (rodízio) dos grupos. */
export default {
    data: () => ({
        configuracaoId: null, turmaId: null, dataInicio: '', dataFim: '',
        configuracoes: [], turmas: [], grupos: []
    }),
    computed: {
        podeEscrever () { return [0, 1, 3, 4, 5, 6, 7, 9, 12].includes(parseInt(this.$store.state.user.tipo)) },
        semRodizio () {
            const c = this.configuracoes.find(x => x.id === this.configuracaoId)
            return !!(c && c.regime_rodizio === 'sem_rodizio')
        },
        /**
         * Faixas distintas presentes nas escalas dos grupos. São montadas a partir do que
         * o backend gravou — a tela não recalcula o rodízio.
         */
        faixas () {
            const mapa = {}
            this.grupos.forEach(g => {
                (g.escalas || []).forEach(e => {
                    const inicio = (e.data_inicio || '').substring(0, 10)
                    const fim = (e.data_fim || '').substring(0, 10)
                    mapa[inicio + '|' + fim] = { chave: inicio + '|' + fim, inicio: inicio, fim: fim }
                })
            })
            return Object.keys(mapa).sort().map(k => mapa[k])
        }
    },
    mounted () {
        const periodo = this.$store.state.config.periodo ? this.$store.state.config.periodo.id : ''

        this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/configuracao-grupo-aluno/getAll/${periodo}`,
            this.$store.getters.getHeaderAuth
        ).then(r => { this.configuracoes = Array.isArray(r.data) ? r.data : [] })
         .catch(e => this.$store.commit('throwException', e))
    },
    methods: {
        rotulo (v) {
            return { diario: 'diário', semanal: 'semanal', quinzenal: 'quinzenal',
                sem_rodizio: 'sem rodízio' }[v] || v
        },
        dataBr (d) {
            if (!d) return '—'
            const p = d.substring(0, 10).split('-')
            return `${p[2]}/${p[1]}`
        },
        corModo (m) {
            return { presencial: 'success', remoto: 'info', hibrido: 'warning' }[m] || 'info'
        },
        modoNaFaixa (g, f) {
            const e = (g.escalas || []).find(x =>
                (x.data_inicio || '').substring(0, 10) === f.inicio &&
                (x.data_fim || '').substring(0, 10) === f.fim)
            return e ? e.modo : null
        },
        configuracaoMudou () {
            this.turmaId = null
            this.grupos = []
            this.turmas = []
            if (!this.configuracaoId) return

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/configuracao-grupo-aluno/turmasElegiveis/${this.configuracaoId}`,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                if (r.data && r.data.erro) return
                // Só faz sentido escolher turma que já tem grupos.
                this.turmas = (r.data.itens || []).filter(t => t.ja_dividida)
            }).catch(e => this.$store.commit('throwException', e))
        },
        carregarEscala () {
            this.grupos = []
            if (!this.turmaId) return

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/grupo-aluno/getByTurma/${this.turmaId}/${this.configuracaoId}`,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }
                this.grupos = r.data.grupos || []
            }).catch(e => this.$store.commit('throwException', e))
        },
        gerar () {
            window.eventBus.$emit('loading', true)
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/grupo-aluno/gerarEscala`,
                { configuracao_grupo_aluno_id: this.configuracaoId,
                  data_inicio: this.dataInicio, data_fim: this.dataFim },
                this.$store.getters.getHeaderAuth
            ).then(r => {
                window.eventBus.$emit('loading', false)
                if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }
                window.eventBus.$emit('alert', { msg: r.data.mensagem, type: 'success' })
                this.carregarEscala()
            }).catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
        },
        textoErro (e) { return typeof e === 'string' ? e : (e.text || 'Não foi possível concluir.') }
    }
}
</script>
